import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { createTool, type ToolDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useCreateTool = (): UseMutationResult<ToolDto, AxiosError, ToolDto> => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (tool) => createTool({ body: tool }).then((result) => result.data!),
        onSuccess: (savedTool) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.tools() });
            showSuccessToast(t('successActionGeneric'));
            navigate({
                pathname: '/content-admin/tools',
                search: `?tool=${savedTool.id}`,
            });
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
